import React from 'react'
import useApi from '../../../hooks/use-api'

const ApiVersion = () => {
    const { version} = useApi()

    if (!version) {
        return null
    }

    return (
        <React.Fragment>v {version}</React.Fragment>
    )
}

export default ApiVersion